import { Row } from 'react-table';

export const getIsRowDisabled = (row: Row<Record<string, unknown>>): boolean =>
  row.original.isDisabled as boolean;
